import React, {useState, useEffect, useRef} from 'react';
import * as S from './OtpBlock.styles';
import * as C from '../../Common.styles';
// import OTPBlock from './OtpInput/OtpInput';
import OTPBlock from '../../../UI/OTP/otp';
import {sendEvarData} from '@ibibo/analytics';
import {validations} from '../../../../../utils/validations';
import {maskEmail, maskMobile} from '../../../../../utils/utils';
import ButtonLoader from '../../../UI/Loader/Loader';
import {NON_EDITABLE_STATUS} from '../../../../../constants';
import Eye from '../CreatePassword/EyeIcon';

const OtpBlock = ({
  onOTPSubmit,
  editField,
  resendOTP,
  email,
  mobile,
  apiError,
  setLoader,
  status,
  mobile_count,
  email_count,
  headingData,
  eu,
  sendOTP,
  submitDetails,
  loginApiError,
  userMobile,
  getToken,
  userCountry,
  is2FARequired,
}) => {
  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const mobileOtpRef = useRef(null);
  const emailOtpRef = useRef(null);
  const [useOtp, setUseOtp] = useState(true);
  const [loginApiErrorMsg, setLoginApiError] = useState(loginApiError);
  // const [errors, setError] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [resetPass, setResetPass] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [{country_code, username, password}, setUserPass] = useState({
    country_code: '+91',
    username: userMobile || '',
    password: '',
  });

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setLoginApiError(loginApiError);
  }, [loginApiError]);

  const fieldValidators = {
    mobile_otp: {
      field: 'mobile_otp',
      fieldName: 'Mobile OTP',
      validators: ['required', 'numeric', 'fixedLength'],
    },
    email_otp: {
      field: 'email_otp',
      fieldName: 'Email OTP',
      validators: ['required', 'numeric', 'fixedLength'],
    },
    password: {field: 'password', fieldName: 'Password', validators: ['required']},
  };

  const fieldName = {
    email: {
      name: 'Email',
      value: email,
    },
    mobile: {
      name: 'Mobile',
      value: userMobile,
    },
  };

  const onChangeHandler = (field, value) => {
    const data = {
      country_code,
      username,
      password,
    };
    data[field] = value;
    setUserPass(data);
  };

  const mobileOtpLen = 6;
  const emailOtpLen = 4;

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            length: key === 'email_otp' ? emailOtpLen : mobileOtpLen,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const verifyOTP = event => {
    event.preventDefault();

    const mOTPStr = mobileOtpRef.current.value;
    // const eOTPStr = emailOtpRef.current.value;

    const data = {
      mobile_otp: mOTPStr,
      //   email_otp: eOTPStr,
    };
    let hasError = false;
    if (NON_EDITABLE_STATUS.indexOf(status) === -1) {
      hasError = validateFields(data);
    }
    if (!hasError) {
      onOTPSubmit(data);
    }
    sendEvarData(
      {
        prop54: 'myPartner|signup|OTPVerification|next',
      },
      true,
    );
  };

  const maskField = (field, value) => {
    switch (field) {
      case 'email':
        return maskEmail(value);
      case 'mobile':
        return maskMobile(value);
    }
  };

  const showpasswordBlock = () => {
    setUseOtp(!useOtp);
  };

  const sendOTPFn = () => {
    const hasError = validateFields({
      country_code,
      username,
    });
    if (!hasError) {
      if (!useOtp) {
        setUseOtp(!useOtp);
        sendOTP({
          username: `${username}`,
        });
      } else {
        setUseOtp(!useOtp);
      }
    }
    sendEvarData(
      {
        prop54: !useOtp
          ? 'myPartner|login|password|loginWithOTP'
          : 'myPartner|login|OTP|loginWithPassword',
      },
      true,
    );
  };

  const submitLogin = event => {
    event.preventDefault();
    const hasError = validateFields({
      country_code,
      username,
      password: useOtp ? mobileOtpRef.current.value : password,
    });
    if (!hasError) {
      const dataObj = {
        username: `${username}`,
      };
      if (useOtp) {
        dataObj.mobile_otp = mobileOtpRef.current.value;
      } else {
        dataObj.password = password;
      }
      submitDetails(dataObj, sendOTPFn);
    }
    sendEvarData(
      {
        prop54: !useOtp ? 'myPartner|login|OTP|login' : 'myPartner|login|password|login',
      },
      true,
    );
  };

  let otpBlock = (
    <C.InputWrapper>
      <C.CommonInputWrap>
        <C.CommonInput
          type={!showPassword ? 'password' : 'text'}
          name="password"
          placeholder="Password"
          value={password}
          onChange={event => onChangeHandler('password', event.target.value)}
          hasError={errors['password'] ? true : false}
        />
        <C.ErrorText>{errors['password']}</C.ErrorText>
        <S.EyeWrapper>
          <Eye showPassword={showPassword} setShowPassword={() => setShowPassword(!showPassword)} />
        </S.EyeWrapper>
      </C.CommonInputWrap>
    </C.InputWrapper>
  );

  if (useOtp) {
    otpBlock = (
      <OTPBlock
        ref={mobileOtpRef}
        label=""
        subLabel=""
        otpLength={mobileOtpLen}
        type="motp"
        error={errors['mobile_otp']}
        resendOTP={resendOTP}
        autoFocus={true}
        resendVisible={mobile_count}
      />
    );
  }

  const getForgotPasswordToken = () => {
    const hasError = validateFields({username});
    if (!hasError) {
      getToken(username);
    }
  };

  return (
    <C.PopContentMainWrap>
      <C.PopContentHeadWrap>
        {(!useOtp && <C.PopContentHeadText>Enter Password to continue</C.PopContentHeadText>) || (
          <>
            <C.PopContentHeadText>Enter OTP to continue</C.PopContentHeadText>
            {userCountry ? (
              <C.PopContentSubHeadText>
                {(eu && 'Login') || 'Sign-up'} &nbsp;OTP has been sent to your email{' '}
                {email && maskField('email', email)}
              </C.PopContentSubHeadText>
            ) : (
              <C.PopContentSubHeadText>
                {is2FARequired ? null : (eu && 'Login') || 'Sign-up'}
                {is2FARequired
                  ? ' Two-Factor Authentication required for this login. '
                  : ' OTP has been sent to your mobile number '}
                {is2FARequired ? null : userMobile && maskField('mobile', userMobile)}
              </C.PopContentSubHeadText>
            )}
          </>
        )}
      </C.PopContentHeadWrap>
      <C.UserInfoForm onSubmit={eu ? submitLogin : verifyOTP}>
        <C.PopContentInnerWrap>
          <S.OtpBlockWrap>
            <S.OtpBlockInnerHeadWrap>
              {/* {eu && useOtp && <S.OtpBlockInnerHeadText>Enter Password</S.OtpBlockInnerHeadText> || <S.OtpBlockInnerHeadText>Enter OTP</S.OtpBlockInnerHeadText>} */}
              {/* <S.OtpBlockResendText>Resend OTP</S.OtpBlockResendText> */}
            </S.OtpBlockInnerHeadWrap>
            <S.OtpMainWrap>{otpBlock}</S.OtpMainWrap>
            <C.ApiErrorText>{apiErrorMsg ? apiErrorMsg.msg : ''}</C.ApiErrorText>
          </S.OtpBlockWrap>
          {(eu && useOtp && !is2FARequired && (
            <S.PasswordBlockWrap>
              <S.PasswordClickWrap>
                <S.PasswordText onClick={showpasswordBlock}>Login with password</S.PasswordText>
              </S.PasswordClickWrap>
              {!userCountry && (
                <S.PasswordResetWrap>
                  <S.PasswordReset onClick={() => getForgotPasswordToken()}>
                    Forgot password
                  </S.PasswordReset>
                </S.PasswordResetWrap>
              )}
            </S.PasswordBlockWrap>
          )) ||
            (eu && (
              <S.PasswordBlockWrap>
                <S.PasswordClickWrap onClick={sendOTPFn}>
                  <S.PasswordText onClick={showpasswordBlock}>Login with OTP</S.PasswordText>
                </S.PasswordClickWrap>
                {!userCountry && (
                  <S.PasswordResetWrap>
                    <S.PasswordReset onClick={() => getForgotPasswordToken()}>
                      Forgot password
                    </S.PasswordReset>
                  </S.PasswordResetWrap>
                )}
              </S.PasswordBlockWrap>
            ))}
          {loginApiErrorMsg ? (
            <S.HeadSubTitleText>
              <S.HeadSubTitleTextSpan>{loginApiErrorMsg}</S.HeadSubTitleTextSpan>
            </S.HeadSubTitleText>
          ) : null}
        </C.PopContentInnerWrap>
        <C.ButtonWrap>
          <C.ContinueButton type="submit">
            {setLoader ? <ButtonLoader loaderType="button" /> : 'Continue'}
          </C.ContinueButton>
        </C.ButtonWrap>
      </C.UserInfoForm>
    </C.PopContentMainWrap>
  );
};

export default OtpBlock;
